module.exports = __webpack_public_path__ + "static/media/icon-goal.f17838e3.svg";